import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import {
    SettingType, CodeBlock, BlockType, ValidationMessage, ValidationMessageType,
} from '@appblocks/codegeneration/types';


export default class DSGroup extends BaseFeature {
    constructor() {
        super();
        this.name = 'DS Manager Group';
        this.id = 'ds_group';
        this.singleInstance = false;
        this.settings = this.settings.concat([
            {
                id: 'ITEMID',
                name: 'Group ID',
                settingType: SettingType.HIDDEN,
                required: true,
                default: 'group',
            },
            {
                id: 'NAME',
                name: 'Group Name',
                settingType: SettingType.STRING,
                required: true,
                default: 'General',
            },
            {
                id: 'SETTINGS',
                name: 'Settings',
                settingType: SettingType.ARRAY,
                refId: 'luis_item',
                required: true,
                showChildren: true,
                default: [],
            },
        ]);
    }

    getDependencies() {
        const dependencies = [
            'ds_man',
        ];
        return dependencies;
    }

    validate(): Array<ValidationMessage> {
        const errors: Array<ValidationMessage> = [];

        const settings = this.getSettingValue('SETTINGS');
        const alphanumeric = /^[a-zA-Z0-9]+$/;
        const ID = this.getSettingValue('ITEMID');
        if (!ID.match(alphanumeric)) {
            errors.push({
                messageType: ValidationMessageType.ERROR,
                message: 'Group ID must be alphanumeric',
            });
        }

        return errors;
    }

    getCodeBlocks() {
        let blocks: Array<CodeBlock> = [];

        const ID = this.getSettingValue('ITEMID');
        const NAME = this.getSettingValue('NAME');
        blocks.push({
            location: 'sdf.xtxt',
            blockType: BlockType.CODE,
            template: `
I=${ID};D=${NAME};T=GROUP;`,
        });

        const settings = this.getSettingValue('SETTINGS');
        for (let i = 0; i < settings.length; i += 1) {
            blocks = blocks.concat(settings[i].getCodeBlocks());
        }

        return blocks;
    }
}
